"use client";

import { HalfLifeCalculatorClient } from "../client";
import type { PeptideData } from "@/lib/calculator/types";
import type { Locale } from "@/config/locale";

interface SpokeClientProps {
	peptide: PeptideData;
	locale: Locale;
}

export function HalfLifeSpokeClient({ peptide, locale }: SpokeClientProps) {
	return (
		<HalfLifeCalculatorClient peptides={[peptide]} initialSlug={peptide.slug} locale={locale} lockPeptide />
	);
}
